import { useSyncExternalStore } from 'react';

type Device = 'mobile' | 'desktop';

const MOBILE_MAX = 767;

function getDevice(): Device {
    // Handle SSR safely by checking if window is defined
    if (typeof window === 'undefined') return 'desktop';

    const w = window.innerWidth;
    if (w <= MOBILE_MAX) return 'mobile';
    return 'desktop';
}

let currentDevice = getDevice();
const listeners = new Set<() => void>();

if (typeof window !== 'undefined') {
    window.addEventListener('resize', () => {
        const next = getDevice();
        if (next !== currentDevice) {
            currentDevice = next;
            listeners.forEach(l => l());
        }
    });
}

export function useDevice() {
    return useSyncExternalStore(
        (cb) => {
            listeners.add(cb);
            return () => listeners.delete(cb);
        },
        () => currentDevice,
        () => 'desktop' // Handle server-side hydration safely
    );
}
